import { constants, typographyStyles } from "@newsela/angelou";

const { colors } = constants;
const { textLObj } = typographyStyles;

const darkBlue = constants.colors.ui.core[700];

export const rootCss = {
  display: "flex",
  borderBottom: `1px solid ${colors.ui.neutral[100]}`,
};

export const tabCss = {
  padding: "6px 0",
  marginRight: "20px",
};

export const selectedStateIndicatorCss = {
  background: darkBlue,
  width: "100%",
  position: "relative",
  height: "5px",
  top: "8px",
};

export const tabTitleCss = [
  {
    margin: 0,
    padding: "0 16px",
  },
  textLObj,
];
